import React, { useState, useEffect } from "react";
import "./BookAppointment.css";

const BookAppointment = ({ clientData, onLogout }) => {
  const [formData, setFormData] = useState({ date: "", time: "", symptoms: "" });
  const [isLoading, setIsLoading] = useState(false);
  const [isBooked, setIsBooked] = useState(false);

  // Get today's date in YYYY-MM-DD format to disable past dates
  const today = new Date().toISOString().split("T")[0];

  useEffect(() => {
    if (isBooked) {
      const timer = setTimeout(() => {
        onLogout();
      }, 6000);
      return () => clearTimeout(timer);
    }
  }, [isBooked, onLogout]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    // 1. Logic to Block Sundays
    if (name === "date" && value) {
      const selectedDate = new Date(value);
      const day = selectedDate.getUTCDay(); 

      if (day === 0) {
        alert("Sundays are holiday. Please select another day (Mon-Sat).");
        setFormData({ ...formData, date: "" });
        return;
      }
    }

    // 2. Logic to Block times outside 10:00 AM - 08:00 PM
    if (name === "time" && value) {
      const [hours, minutes] = value.split(':').map(Number);
      const timeInMinutes = hours * 60 + minutes;
      
      const startLimit = 10 * 60; // 10:00 AM
      const endLimit = 20 * 60;   // 08:00 PM (20:00)

      if (timeInMinutes < startLimit || timeInMinutes > endLimit) {
        alert("Please select a time between 10:00 AM and 08:00 PM.");
        setFormData({ ...formData, time: "" });
        return;
      }
    }

    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const response = await fetch('/api/db', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 
          action: 'book', 
          data: { 
            user_id: clientData.id, 
            date: formData.date, 
            time: formData.time, 
            symptoms: formData.symptoms 
          } 
        })
      });
      const result = await response.json();
      
      if (result.error || !response.ok) {
        alert("Failed to book: " + (result.error || "Server error"));
        setIsLoading(false);
        return;
      }

      setIsBooked(true);
      setIsLoading(false);
      
    } catch (err) {
      alert("Network error. Please try again.");
      setIsLoading(false);
    }
  };

  return (
    <div className="appointment-container">
      <div className="appointment-box">
        {isBooked ? (
          <div className="success-message">
            <div className="success-icon">✓</div>
            <h3>Appointment Requested!</h3>
            <p>Dr. Shivani's team will review your request shortly.</p>
            <p className="redirect-hint">Returning to home in 5 seconds...</p>
            <button className="book-btn" onClick={onLogout}>Done Now</button>
          </div>
        ) : (
          <>
            <button className="back-btn-top" onClick={onLogout}>← Back</button>
            <h2>Book Appointment</h2>
            
            {isLoading ? (
              <div className="loading-box"><div className="spinner"></div><p>Saving...</p></div>
            ) : (
              <>
                <div className="client-info">
                  <p>Patient: <strong>{clientData.name}</strong></p>
                </div>

                <form onSubmit={handleSubmit} className="vertical-form">
                  <div className="form-group">
                    <label>Date</label>
                    <input 
                      type="date" 
                      name="date" 
                      min={today}
                      value={formData.date} 
                      onChange={handleChange} 
                      required 
                    />
                  </div>

                  <div className="form-group">
                    <label>Time (10 AM - 8 PM)</label>
                    <input 
                      type="time" 
                      name="time" 
                      min="10:00"
                      max="20:00"
                      value={formData.time} 
                      onChange={handleChange} 
                      required 
                    />
                  </div>

                  <div className="form-group">
                    <label>Symptoms</label>
                    <textarea
                      name="symptoms"
                      placeholder="Describe your issue here..."
                      value={formData.symptoms}
                      onChange={handleChange}
                    />
                  </div>

                  <button type="submit" className="book-btn">Confirm Booking</button>
                </form>
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default BookAppointment;
